/* BFV Zine Club: prepare one Ajax add request; Spotlight owns the submission UI. */
if (!customElements.get('bfv-print-option')) {
  customElements.define('bfv-print-option', class extends HTMLElement {
    // Shopify may partially accept an add; cap only this linked printing product.
    static async reconcileCart(cart, sections = []) {
      const root = window.Shopify.routes.root;
      if (!cart) {
        const response = await fetch(root + 'cart.js');
        if (!response.ok) throw new Error('Unable to verify workshop cart');
        cart = await response.json();
      }
      const limit = cart.items.length + 1;
      for (let attempts = 0; attempts < limit; attempts++) {
        const index = cart.items.findIndex((item) => {
          if (item.variant_id !== 54977346732375 || !item.parent_relationship?.parent_key) return false;
          const parent = cart.items.find((line) => line.key === item.parent_relationship.parent_key);
          return item.quantity > (parent?.quantity || 0);
        });
        if (index < 0) return cart;
        const child = cart.items[index];
        const parent = cart.items.find((line) => line.key === child.parent_relationship.parent_key);
        const response = await fetch(root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: index + 1, quantity: parent?.quantity || 0,
            sections, sections_url: window.location.pathname }),
        });
        const updated = await response.json();
        if (!response.ok || updated.errors) throw new Error('Unable to update linked printing quantity');
        cart = updated;
      }
      throw new Error('Unable to reconcile linked printing quantity');
    }

    connectedCallback() {
      const color = this.querySelector('[data-print-color]');
      if (color) color.disabled = false;
    }

    prepare(formData) {
      const colorSelected = formData.get('bfv_print_option') === 'Color';
      // The paid child line is the source of truth, even after customers remove it.
      formData.delete('bfv_print_option');
      if (!colorSelected) return formData;

      const body = new FormData();
      // Preserve workshop quantity, selling plan, and all existing app/participant properties.
      for (const [name, value] of formData.entries()) {
        if (name === 'id' || name === 'quantity' || name === 'selling_plan') {
          body.append(`items[0][${name}]`, value);
        } else if (name.startsWith('properties[')) {
          body.append(`items[0][properties]${name.slice('properties'.length)}`, value);
        } else {
          body.append(name, value);
        }
      }
      if (!formData.has('quantity')) body.append('items[0][quantity]', '1');
      body.append('items[1][id]', this.dataset.addonVariantId);
      body.append('items[1][quantity]', formData.get('quantity') || '1');
      // Shopify removes this child automatically when its workshop parent is removed.
      body.append('items[1][parent_id]', formData.get('id'));
      return body;
    }
  });
}
